import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export interface ActivityGoalItemsProps {
  title: string;
  items: string[];
}

export const ActivityGoalItems = ({ value, onChange }) => {
  const [model, setModel] = useState<ActivityGoalItemsProps>(value || { title: "Default", items: [""] });

  useEffect(() => {
    setModel(value);
  }, [value]);

  const onValue = (i, val) => {
    const { title, items } = model;
    items[i] = val;
    onChange && onChange({ title, items });
  };

  const onAdd = () => {
    onChange && onChange({ ...model, items: [...model.items, ""] });
  };

  const onDel = (i) => {
    const { title, items } = model;
    items.splice(i, 1);
    onChange && onChange({ title, items: [...items] });
  };

  return (
    <div>
      <div>{model.title}</div>
      <div>
        {model.items.map((x, i) => (
          <Input
            addonAfter={model.items.length > 1 && <DeleteOutlined onClick={() => onDel(i)} />}
            key={i + ""}
            value={x}
            onChange={(e) => onValue(i, e.target.value)}
            allowClear={true}
          />
        ))}
      </div>
      <div>
        <Button onClick={onAdd}>+</Button>
      </div>
    </div>
  );
};
